import { useLayoutEffect } from 'react';
import { tTheme } from './themeConfig';
import { pushNativeThemeOverride } from './nativeTheme';

// Screens with a fixed background pass the theme that background reads as; null leaves the app theme.
export function useStatusBarOverride(theme: tTheme | null): void {
  useLayoutEffect(() => {
    if (!theme) return undefined;

    return pushNativeThemeOverride(theme);
  }, [theme]);
}
